<template>
  <div class="image-container">
    <div class="overlay"></div>
    <img :src="require('@/assets/img/inicio.jpeg')" alt="Imagen de inicio" class="full-image" />
  </div>
</template>

<script>
export default {
  name: "MiComponente"
};
</script>

<style scoped>
/* Contenedor que envuelve la imagen */
.image-container {
  position: relative; /* Esto es necesario para posicionar el overlay sobre la imagen */
  width: 100%;
  height: 100vh; /* O cualquier altura que necesites */
}

/* Imagen que ocupa todo el espacio */
.full-image {
  width: 100%;
  height: 100vh;
  object-fit: cover; /* Esto asegura que la imagen cubra todo el contenedor sin deformarse */
}

/* Capa transparente que va encima de la imagen */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fondo negro con opacidad */
  z-index: 1; /* Asegúrate de que el overlay esté encima de la imagen */
}
</style>
